import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { IconButton } from "@mui/material"
import { PeopleAltOutlined } from "@mui/icons-material"
import { upsellingTitle } from "helpers/op-pro"
import Tooltip from "components/material/tooltip"

export default function PermissionButton({ account, resource, isOpPro }) {
  const { alias, shortType, resourceType } = resource
  const isDisabled = (resourceType) => {
    // Only OpPro has limited resource type permissions
    if (!isOpPro) { return false }
    return resourceType !== "portfolio"
  }
  const defaultTab = isOpPro ? "applications" : "members"

  return isDisabled(resourceType) ? <Tooltip title={upsellingTitle(isOpPro, resourceType)}>
    {/* the span is to allow the Tooltip to work on a disabled button */}
    <span>
      <IconButton disabled size="large">
        <PeopleAltOutlined />
      </IconButton>
    </span>
  </Tooltip>
    : <IconButton
        component={Link}
        to={`/${account}/${shortType}/${alias}/permissions/${defaultTab}`}
        size="large"
    >
      <PeopleAltOutlined />
    </IconButton>
}

PermissionButton.propTypes = {
  account: PropTypes.string.isRequired,
  resource: PropTypes.shape({
    alias: PropTypes.string.isRequired,
    shortType: PropTypes.string.isRequired,
    resourceType: PropTypes.string.isRequired,
  }),
  isOpPro: PropTypes.bool.isRequired,

}
